import {HttpErrorResponse} from '@angular/common/http';
import {Component, ElementRef, OnInit, QueryList, ViewChild, ViewChildren} from '@angular/core';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort, SortDirection} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {FabTableState, filterStateChange, process} from '@fabric/components/table-filter/data-query';
import {catchError, EMPTY, map, Observable} from 'rxjs';
import {ErrorCodes} from '../../constants/ErrorCodes';
import {UserFunctionCode} from '../../constants/UserFunctionCode';
import {ViewRemitos} from '../../models/ViewRemitos';
import {NotificationService} from '../../services/notification.service';
import {RemitoService} from '../../services/remito.service';
import {SecurityService} from '../../services/security.service';
import {FabDateFilterOperator,
  RemDateFilterComponent,
  } from '../../shared-components/table-filter/date-filter/date-filter.component';
import {
  PopupCancelRemitoDialogComponent
} from '../../shared-components/popup-cancel-remito-dialog/popup-cancel-remito-dialog.component';
import {RemitoTypes} from "../../constants/RemitoTypes";
import {FabStringFilterOperator, RemStringFilterComponent} from '../../shared-components/table-filter/string-filter/string-filter.component';
import { RemNumberFilterComponent } from 'src/app/shared-components/table-filter/number-filter/number-filter.component';

@Component({
  selector: 'app-view-remitos',
  templateUrl: './view-remitos.component.html',
  styleUrls: ['./view-remitos.component.scss']
})
export class ViewRemitosComponent implements OnInit {

  isLoading: boolean = false;
  initialLoadingCompleted = false;

  displayedColumns: string[] = [
    'nroRemito', 'remitoType', 'nroShipper', 'nameSolicitante', 'codAlmacen', 'dock', 'fecGen',
    'fecModif', 'fecARetornar', 'fecProrrogas', 'fecRetorno', 'estadoRemito', 'remitoButtons'
  ];
  dataSource: MatTableDataSource<ViewRemitos> = new MatTableDataSource<ViewRemitos>();
  allRemitos: ViewRemitos[] = [];

  operators: FabStringFilterOperator[] = ['contains'];
  public dateOperators: FabDateFilterOperator[] = ['eq', 'gte', 'lte'];

  state: FabTableState = {
    skip: 0,
    take: 5,
    filter: [],
    sort: []
  };
  remitoNumber: any[] = [];

  get printEmailNros(): { ptoEmision: string, nroRemito: number }[] {
    return this.remitoNumber.map((r) => {
      return {ptoEmision: r.ptoEmision, nroRemito: r.nroRemito}
    });
  }

  errors: HttpErrorResponse[] = [];

  showPrintEmailAllButtons: boolean = true;
  canPrint: boolean = false;
  canEmail: boolean = false;
  canCancel: boolean = true;

  disableRemitoButtons: boolean = false;
  disablePrintEmailAllButtons: boolean = true;
  disableUnchecked: boolean = false;

  @ViewChild(MatPaginator) private paginator: MatPaginator;
  @ViewChild(MatSort) matSort: MatSort;

  initialSortField = 'fecGen';
  initialSortDirection: SortDirection = 'desc';

  pageSizes = [10, 15, 20, 25];
  totalElements: number = 0;
  selector: string;

  @ViewChild('dataTable', {read: ElementRef}) dataTable: ElementRef;

  // @ts-ignore
  @ViewChildren('tableFilter') tableFilters:
    QueryList<RemStringFilterComponent | RemNumberFilterComponent | RemDateFilterComponent>;

  constructor(private remitoService: RemitoService, private notificationService: NotificationService,
              private securityService: SecurityService, private dialog: MatDialog,
              private elementRef: ElementRef) {  }

  ngOnInit(): void {
    this.isLoading = true;
    this.setSecurityRoles();
    this.selector = this.elementRef.nativeElement.tagName.toLowerCase();
  }

  ngAfterViewInit(): void {
    this.fetchInitialData(true);
  }

  fetchInitialData(addCheckBox: boolean) {
    this.isLoading = true;
    this.initialLoadingCompleted = false;
    this.matSort.active = this.initialSortField;
    this.matSort.direction = this.initialSortDirection;
    this.tableFilters.toArray().forEach((x) => x.clearFilter());
    this.matSort.sortChange.emit();
    this.requestPage().subscribe(() => {
      this.showPrintEmailAllButtons = (this.canPrint && this.canEmail) && this.allRemitos.length > 0;
      if (this.showPrintEmailAllButtons && addCheckBox) {
        this.displayedColumns.unshift('checkbox');
      }
      this.isLoading = false;
      this.initialLoadingCompleted = true;
    });
  }

  setRemitos(response: ViewRemitos[]): void {
    this.allRemitos = response;

    for (var i = 0; i < this.allRemitos.length; i++) {

      if (this.allRemitos[i].descAlmacen != null) {
        this.allRemitos[i].almacen = this.allRemitos[i].codAlmacen + "-" + this.allRemitos[i].descAlmacen;
      }else{
        this.allRemitos[i].almacen ='';
      }
    }

    this.dataSource = new MatTableDataSource<ViewRemitos>(this.allRemitos);
  }

  setSecurityRoles(): void {
    // determine if user can print, email, or cancel
    this.canPrint = this.securityService.can(UserFunctionCode.PRINT_REMITO);
    this.canEmail = this.securityService.can(UserFunctionCode.EMAIL_REMITO);
    this.canCancel = this.securityService.can(UserFunctionCode.CANCEL_REMITO);
  }

  // On checkbox change
  onChange(element: any) {
    if (element.isChecked) {
      this.remitoNumber.push(element);
    } else {
      for (var i = 0; i < this.remitoNumber.length; i++) {
        if (this.remitoNumber[i].nroRemito === element.nroRemito) {
          this.remitoNumber.splice(i, 1);
        }
      }
    }
    // Disable print and email button if at least 1 balanza is checked
    this.disablePrintEmailAllButtons = (this.remitoNumber.length === 0) || (this.remitoNumber.find(remito => remito.origen.toUpperCase() === 'BAL'));
    this.disableRemitoButtons = this.remitoNumber.length > 0;
  }

  public clearAllFilters() {
    this.tableFilters.toArray().forEach((x) => x.clearFilter());
  }

  public filterChange(event: any) {
    this.uncheckAll();
    this.state.skip = 0;
    this.state.filter = filterStateChange(event, this.state.filter ?? []);
    this.updatePageState();
  }

  onSortChange() {
    this.paginator.pageIndex = 0;
    this.updatePageState();
  }

  scrollTableToTop() {
    this.dataTable.nativeElement.scrollIntoView();
  }

  updatePageState() {
    if (this.initialLoadingCompleted) {
      this.isLoading = true;
      this.requestPage().subscribe(() => {
        this.isLoading = false;
      });
    }
  }

  uncheckAll() {
    this.allRemitos.forEach(r => r.isChecked = false);
  }

  requestPage(): Observable<any> {
    return this.remitoService.getAllRemitosPaged(
      this.paginator.pageIndex,
      this.paginator.pageSize,
      [this.matSort.active],
      this.matSort.direction,
      this.state.filter ?? []
    ).pipe(
      map((response) => {
        this.setRemitos(response.data);
        this.totalElements = response.total;
        this.paginator.pageIndex = response.page;
        this.paginator.pageSize = response.pageSize;
        this.scrollTableToTop();
        return EMPTY;
      }), catchError((error) => {
        this.notificationService.open(this.notificationService.getErrorByCode(error.error.errorCode), 'error');
        this.allRemitos = [];
        this.dataSource = new MatTableDataSource<ViewRemitos>([]);
        this.totalElements = 0;
        return EMPTY;
      })
    );
  }

  /**
   * Opens a {@link .PopupCancelRemitoDialogComponent PopupCancelRemitoDialog}. If the cancellation is
   * successful, the row is updated; otherwise, the dialog closes without change.
   * @param     remito      the Remito reference
   * @returns   {ViewRemitos} the Remito updated cancellation data
   */
  public cancelarRemito(remito: ViewRemitos): ViewRemitos {
    const dialogRef = this.dialog.open(PopupCancelRemitoDialogComponent, {
      data: {
        remito: remito,
        isReadOnly: false
      }
    });
    return this.afterClosed(dialogRef, remito);
  }

  /**
   * Opens readonly dialog with cancel information
   * @param remito  the Remito reference
   */
  public verCancelarObservacion(remito: ViewRemitos) {
    this.dialog.open(PopupCancelRemitoDialogComponent, {
      data: {
        remito: remito,
        isReadOnly: true
      }
    });
  }

  /**
   * After closing the dialog, if the {@link data} is `null`, the results will be ignored. This prevents false
   * error/success from the user either exiting the dialog without submitting or clicking outside the popup window.
   *
   * Next, if `"error"` is returned, then the call to the backend endpoint failed, so an error notification
   * toast is shown to the user.
   *
   * Finally, in a successful submission, the Remito is returned and updated in the View All Remitos table, and
   * a success notification toast is shown to the user.
   * @param {MatDialogRef<PopupCancelRemitoDialogComponent>} dialogRef
   * @param {ViewRemitos} remito
   * @return {ViewRemitos}
   * @private
   */
  private afterClosed (dialogRef: MatDialogRef<PopupCancelRemitoDialogComponent>, remito: ViewRemitos): ViewRemitos {
    dialogRef.afterClosed().subscribe(data => {
      if (data != null) {
        if ("error" === data) {
          this.notificationService.open(ErrorCodes.CANCELAR_FALLIDO, 'error');
        } else {
          this.fetchInitialData(false);
          this.notificationService.open(ErrorCodes.CANCELAR_CON_EXITO, 'success');
        }
      }
    })
    return remito;
  }

  /**
   * Returns true if the given Remito has Estado = 'Cancelado'
   * @param remito
   */
  estaCancelado(remito: ViewRemitos) {
    return remito.estadoRemito == 'Cancelado';
  }

  /**
   * Returns true if the remito has Origen "FRE" and false otherwise.
   *
   * Note: Per requirement changes Dec 13 2022, MGO Remitos can also be cancelled, so this is not needed
   * at this time.
   * @param {ViewRemitos} remito  The remito being checked
   * @return {boolean}            Returns true if the remito is a Free Remito
   */
  isFreeRemito(remito: ViewRemitos) {
    return remito.remitoType == RemitoTypes.FREE;
  }

  isBalanza(remito: ViewRemitos) {
    return remito.remitoType === RemitoTypes.BALANZA;
  }

  refreshRemitoList() {
    this.fetchInitialData(false);
    this.disableRemitoButtons = false;
    this.remitoNumber = [];
    this.disableUnchecked = false;
  }
}
